import skill from "./skill";
import selftaught from "./selftaught";
import resource from "./resource";
import night from "./night";
import exemption from "./exemption";
import content from "./content";
import army from "./army";
import education from "./education";

/**
 * 华博特项目接口文档
 */
export default {
  skill,
  selftaught,
  resource,
  night,
  exemption,
  content,
  army,
  education,
};
